function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_13014",
  "data-name": "Group 13014",
  transform: "translate(18959 18738)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_12587",
  "data-name": "Group 12587",
  transform: "translate(-18955.99 -18736)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M262.588,830.977a2.46,2.46,0,1,1-3.479-3.479l5.206-5.206v1.628h2.023V818.86h-5.058v2.023h1.582l-5.183,5.183a4.484,4.484,0,0,0,6.341,6.341l2.744-2.744-1.448-1.414Z",
  transform: "translate(-256.367 -818.86)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M425.822,924.7a4.479,4.479,0,0,0-7.65-3.171l-2.392,2.392,1.448,1.414,2.375-2.375a2.46,2.46,0,0,1,3.479,3.479l-4.939,4.939V929.8H416.12v5.059h5.059v-2.023h-1.636l4.969-4.969A4.456,4.456,0,0,0,425.822,924.7Z",
  transform: "translate(-406.833 -914.526)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_26",
  "data-name": "Rectangle 26",
  width: 24,
  height: 24,
  transform: "translate(-18959 -18738)",
  fill: "none"
}));

function SvgProductsFocused(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsFocused);
export default __webpack_public_path__ + "static/media/products_focused.04d23da7.svg";
export { ForwardRef as ReactComponent };